import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';


//https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/Slider/Slider.js
const styles = {
  root: {
    position: 'fixed',
    top: 'calc(50% - 50px)',
    left: 'calc(50% - 50px)',
    // transform: 'translate(-50%, -50%)',
  },

  colorPrimary: {
    color: 'rgb(0, 189, 181)',
  },
};


class Spinner extends Component {

  classes = this.props.classes;

  render() {

    return (
      <div className={this.classes.root}>
        <CircularProgress
          // disableShrink
          size={100}
          classes={{ colorPrimary: this.classes.colorPrimary }}
        />
      </div>
    );
  }
}

Spinner.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { name: 'MuiCircularProgress' })(Spinner);
